import { editProfileURL, pingUrl } from "../api/endpoints";
import store from "../app/store";
import { uiAlert } from "../components/alerts/customAlert/uiAlert";
import { addToQueue, removeFromQueue, setIsSyncOnGoing } from "../slice/offlineQueue";
import { setUser } from "../slice/webStoreUserSlice";
import { refreshUserToken } from "./refreshToken";

export const syncOfflineQueue = async () => {
  //const state = store.getState();

  /* store.dispatch(emptyQueue());  */ //for emergency
  if (!(await canSyncNow())) {
    return {
      success: false,
      message: "No internet connection. Please check your connection and try again.",
    };
  }

  if (store.getState().offlineQueue.IsSyncOnGoing) {
    return {
      success: false,
      message: "Sync is already in progress. Please wait for it to complete before trying again.",
    };
  }

  let allSynced = true;

  if (store.getState().offlineQueue.queue.length > 0) {
    store.dispatch(setIsSyncOnGoing(true));
    try {
      while (store.getState().offlineQueue.queue.length > 0) {
        const item = store.getState().offlineQueue.queue[0];

        const { fetchPayload, fetchUrl, fetchMethod, queueID } = item;

        console.log("Attempting to sync:", queueID, fetchMethod, fetchUrl, fetchPayload);

        try {
          const response = await fetch(fetchUrl, {
            method: fetchMethod,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            body: JSON.stringify(fetchPayload),
          });

          if (response.ok) {
            store.dispatch(removeFromQueue(queueID));

            console.log("Synced and removed:", queueID);
          } else if (response.status === 400) {
            const refreshed = await refreshUserToken(fetchUrl);

            if (!refreshed) {
              console.log("Refresh failed, stopping sync");
              allSynced = false;

              break;
            }

            continue; // retry same item
          } else {
            allSynced = false;

            break;
          }
        } catch (error) {
          console.log("Network error:", error);
          allSynced = false;
          break;
        }
      }

      // Fetch updated user after all sync done

      try {
        const response = await fetch(editProfileURL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        });

        if (!response.ok) {
          return {
            success: false,
            message: allSynced
              ? "Data synced, but failed to fetch updated user data. Please refresh the app."
              : "Some data synced, but sync was incomplete and updated user data could not be fetched.",
          };
        }

        const user = await response.json();

        store.dispatch(setUser(user));

        return {
          success: allSynced,
          message: allSynced ? "All offline actions synced successfully!" : "Some actions failed to sync. Please refresh the app to see the updated data.",
        };
      } catch (error) {
        console.log("User fetch error:", error);
        return {
          success: false,
          message: allSynced
            ? "Data synced, but failed to fetch updated user data. Please refresh the app."
            : "Some data synced, but sync was incomplete and updated user data could not be fetched.",
        };
      }
    } finally {
      store.dispatch(setIsSyncOnGoing(false));
    }
  } else {
    console.log("offline queue is empty");
    return {
      success: true,
      message: "Offline queue is empty",
    };
  }
};

const canSyncNow = async () => {
  if (!navigator.onLine) return false;

  try {
    const res = await fetch(pingUrl, {
      method: "GET",
      cache: "no-store",
    });
    return res.ok;
  } catch {
    return false;
  }
};
